// extracted by mini-css-extract-plugin
module.exports = {"swiper":"carousel-v3_swiper__fWMij"};